import { StyleSheet } from 'react-native';

import { pt, px } from '../../common/utils';

export default StyleSheet.create({
    container: {
        backgroundColor: '#fff',
        width: pt(375),
        paddingVertical: pt(20),
        position: 'relative',
        flex: 1
    },
    title: {
        height: pt(30),
        justifyContent: 'center',
        marginBottom: pt(5),
        marginLeft: pt(10)
    },
    s_view: {
        marginTop: pt(10),
        paddingVertical: pt(10),
        // height: pt(260),
        // backgroundColor: 'pink',
        flex: 1
    },
    // 优惠券列表
    coupon: {
        flexDirection: 'row',
        margin: pt(10),
        marginTop: 0,
        width: '90%',
        marginLeft: pt(-2)
    },
    viewList: {
        backgroundColor: '#fff'
    },
    coupon_list: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    cou_left: {
        width: pt(125),
        height: pt(100),
        justifyContent: 'center',
        alignItems: 'center'
        // resizeMode:'contain',
    },
    p_text: {
        backgroundColor: 'transparent',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    left_bs: {
        alignSelf: 'flex-end',
        marginBottom: pt(10),
        marginRight: pt(5)
    },
    l_txt: {
        color: '#fff',
        alignItems: 'center',
        // textAlign:'center',
        backgroundColor: 'transparent'
    },
    bigtxt: {
        fontSize: pt(45)
    },
    left_img: {
        width: pt(125),
        height: pt(100),
        justifyContent: 'center'
        // resizeMode:'contain'
    },
    cou_right: {
        padding: pt(10),
        width: pt(220),
        justifyContent: 'space-between',
        borderWidth: px(1),
        borderColor: 'rgba(0,0,0,.1)',
        borderLeftWidth: 0,
        backgroundColor: '#fff'
    },

    login: {
        height: pt(25),
        width: pt(85),
        borderRadius: pt(22),
        // borderWidth: pt(1),
        // borderColor:'#5293d5',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: pt(-10)
    },
    touse: {
        position: 'absolute',
        right: pt(20),
        top: '53%'
    },
    touseview: {
        height: pt(22),
        width: pt(76),
        borderRadius: pt(22),
        borderWidth: px(1),
        borderColor: '#5293d5',
        justifyContent: 'center',
        alignItems: 'center'
    },
    touse_txt: {
        color: '#5293d5',
        paddingHorizontal: pt(5),
        fontSize: pt(12)
    },

    touse_j: {
        borderColor: '#fe828c'
    },

    touse_j_txt: {
        color: '#fe828c'
    },
    limit: {
        paddingRight: pt(10),
        width: '100%',
        color: '#898989',
        fontSize: pt(12)
    },
    endTime: {
        color: '#898989',
        fontSize: pt(12)
    },
    couponj_tip: {
        backgroundColor: '#fe828c',
        marginRight: pt(5),
        borderRadius: pt(3),
        paddingHorizontal: pt(5),
        height: pt(17),
        justifyContent: 'center',
        alignItems: 'center'
    },
    coupontxt: {
        fontSize: pt(12),
        color: '#fff'
    },
    coupond_tip: {
        backgroundColor: '#5293d5',
        marginRight: pt(5),
        borderRadius: pt(3),
        paddingHorizontal: pt(5),
        height: pt(17),
        justifyContent: 'center',
        alignItems: 'center'
    },
    righttxt: {
        width: pt(170),
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    coupong_tip: {
        backgroundColor: '#BBB',
        marginRight: pt(5),
        borderRadius: pt(3),
        paddingHorizontal: pt(5),
        height: pt(17),
        justifyContent: 'center',
        alignItems: 'center'
    },
    nomore: {
        justifyContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        paddingTop: pt(70)
    },
    nomore_img: {
        height: pt(50),
        resizeMode: 'contain',
        marginVertical: pt(10)
    },
    nomoretxt: {
        color: '#bfbfbf',
        justifyContent: 'center',
        alignSelf: 'center',
        height: pt(50),
        marginTop: pt(10),
        fontSize: pt(14)
    },
    title_txt: {
        flexDirection: 'row'
    },
    head: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: pt(10)
        // height: pt(40)
    },
    title: {
        fontSize: pt(18)
    },
    close: {
        height: pt(25),
        width: pt(25)
    },

    // tabBar
    change_tab: {
        flexDirection: 'row',
        height: pt(40),
        // paddingHorizontal:pt(6),
        justifyContent: 'center',
        position: 'relative'
    },
    changetab_left: {
        paddingRight: pt(12)
    },
    changetab_right: {
        paddingLeft: pt(12)
    },
    tabStart: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        borderBottomWidth: px(1),
        borderColor: '#e0e0e0',
        height: pt(40)
    },
    tab: {
        fontSize: pt(13),
        color: '#666'
    },
    selectTab: {
        // color:'#E2231A'
        fontWeight: 'bold'
    },
    table_line: {
        height: px(5),
        backgroundColor: '#E2231A',
        width: pt(90),
        position: 'absolute',
        bottom: 0,
        zIndex: 100
    },
    tabimg: {
        position: 'absolute',
        bottom: 0
    },
    /*  无优惠券 */
    no_coupon: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: pt(20)
    },
    img_no: {
        resizeMode: 'contain',
        height: pt(53),
        width: pt(85),
        marginBottom: pt(10),
        marginTop: pt(30)
    },
    no_text: {
        color: '#ccc',
        fontSize: pt(12)
    },
    bottom: {
        height: pt(40),
        marginTop: pt(10),
        justifyContent: 'center',
        alignItems: 'center'
    },
    btn: {
        height: pt(40),
        width: pt(180),
        borderRadius: pt(40),
        backgroundColor: '#E2231A',
        justifyContent: 'center',
        alignItems: 'center'
    },
    btn_txt: {
        color: '#fff',
        fontSize: pt(16)
    }
});
